import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Jcktl { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '單號 (TL001) 不可空白'}) 
    @MaxLength(20,{message: '單號 (TL001) 資料太長'})
    TL001: string = '';            // 單號 20 ** 建檔時間 20220601-150245755  i-ching

    @MaxLength(8,{message: '日期 (TL002) 資料太長'})
    TL002: string = '';            // 日期 8 

    @MaxLength(10,{message: '問卦者 (TL003) 資料太長'})
    TL003: string = '';            // 問卦者 10 

    @MaxLength(1,{message: '時間 (TL004) 資料太長'})
    TL004: string = '';            // 時間 1 

    @MaxLength(20,{message: '分類 (TL005) 資料太長'})
    TL005: string = '';            // 分類 20 

    TL006: string = '';            // 問題 0 

    TL007: string = '';            // 回答 0 

    @IsNumber() 
    TL008: number = 0;            // 上卦 6 

    @IsNumber() 
    TL009: number = 0;            // 下卦 6 

    @IsNumber() 
    TL010: number = 0;            // 變爻 6 

    @IsNumber() 
    TL011: number = 0;            // 年齡 6 

    @MaxLength(2,{message: '性別 (TL012) 資料太長'})
    TL012: string = '';            // 性別 2 


    TL013: Date | undefined;            // DateTime 0 


}
